import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.background.grey2,
    padding: theme.spacing(5, 4),
    margin: theme.spacing(3, 0),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch',
    alignItems: 'stretch',
    width: '100%',
    position: 'relative',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      padding: theme.spacing(3),
    },
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(3, 2.5, 3, 0),
      '&:last-child': {
        marginRight: theme.spacing(0),
      },
      width: '35%',
    },
  },
  iconWrapper: {
    marginRight: theme.spacing(1),
    lineHeight: 1,
    marginBottom: theme.spacing(2),
  },
  text: {
    marginTop: theme.spacing(1),
  },
  bold: {
    fontWeight: 500,
    marginTop: 2,
  },
  greyText: {
    color: theme.palette.text.lightGrey,
  },
  textWrapper: {
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'space-between',
  },
}))
